const initialState = {
    selectedCombinedMenus: []
};

const state = Object.assign({}, initialState);

const getters = {
    selectedCombinedMenus: state => state.selectedCombinedMenus,
};

const mutations = {
    setSelectedCombinedMenus: (state, selectedCombinedMenus) => (state.selectedCombinedMenus = selectedCombinedMenus),
};

export default {
    state,
    getters,
    mutations
};